export default __webpack_public_path__ + "static/media/expedition-team-bg-1.d2b87cb1.png";